const styles = theme => ({
  root: {
    margin: '0 8px 8px',
    padding: '8px',
    borderRadius: '8px',
    backgroundColor: '#FFF8F0',
    border: '1px solid #FFE0B2',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginBottom: '4px',
    cursor: 'pointer',
  },
  // Collapsed there is nothing below to separate from, and the gap would leave the row sitting
  // above the centre of the panel.
  headerCollapsed: {
    marginBottom: 0,
  },
  // Same amber as the per-page marker and the top-bar button, so the three read as one signal.
  dot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '#FF9800',
    flexShrink: 0,
  },
  headerText: {
    fontFamily: 'Inter',
    fontSize: '11px',
    fontWeight: 600,
    color: '#B76E00',
    textTransform: 'uppercase',
    letterSpacing: '0.03em',
    flexGrow: 1,
  },
  // Pushed to the far right by the header text growing into the gap between them.
  toggleIcon: {
    color: '#B76E00',
    flexShrink: 0,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '3px 2px',
    borderRadius: '4px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#FFF1E0',
    },
  },
  pageTitle: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 400,
    color: '#454F5B',
    flexGrow: 1,
    minWidth: 0,
  },
  // Grey: nobody can see this page yet.
  draftBadge: {
    backgroundColor: '#F4F6F8',
    color: '#637381',
    fontFamily: 'Inter',
    fontSize: '10px',
    fontWeight: 600,
    borderRadius: '4px',
    padding: '1px 6px',
    whiteSpace: 'nowrap',
  },
  // Amber: live, but what learners see is out of date.
  editedBadge: {
    backgroundColor: '#FFE9CC',
    color: '#B76E00',
    fontFamily: 'Inter',
    fontSize: '10px',
    fontWeight: 600,
    borderRadius: '4px',
    padding: '1px 6px',
    whiteSpace: 'nowrap',
  },
})

export default styles
